
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setDoorsOrdered = (doorsOrdered: libTypes.Order['doorsOrdered']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.doorsOrdered = fns.order.set.doorsOrdered(doorsOrdered);
        })
    });
};
